import top_cloud from '../../../assets/images/graphic-cloud-2.svg';
import bottom_cloud from '../../../assets/images/graphic-cloud-1.svg';
import star from '../../../assets/images/graphic-star.svg';
import icon_epic from '../../../assets/images/icon-epic-01.svg';
import epic from '../../../assets/images/epic-style-gaming.png';

import icon_st_kilda from '../../../assets/images/icon-st-kilda-01.svg';
import icon_port_phillip from '../../../assets/images/icon-port-phillip-01.svg';

import styled from 'styled-components';

export const Wrapper = styled.div`
padding-top: 3rem;
margin-bottom: 3rem;
width: 100%;
max-width: 1640px;

  .locations-layout {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 1fr;
    row-gap: 0.5rem;
  }

  .st-kilda-item, .port-melbourne-item {
    position: relative;
  }

  @media (min-width: 992px) {
    .locations-layout {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-template-rows: 1fr;
      column-gap: 0.5rem;
    }
  }

  .clear-header {
    display: inline-block;
    width: 90%;
    max-width: 90%;
    height: 100px;
  }
  .blue-body {
    border: 8px solid var(--black);
    background-color: var(--nighttime);
    border-radius: var(--fat-border-radius);
    position: relative;
    display: inline-block;
    width: 90%;
    max-width: 90%;
    min-height: 490px;
    padding-top: 3rem;
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .circle-icon {
    position: absolute;
    border: 8px solid var(--black);
    background-color: var(--accent1);
    border-radius: 50%;
    width: 160px;
    height: 160px;
    top: -90px;
    left: 0;
    right: 0;
    margin: 0 auto;
    z-index: 12;
  }
  .top-cloud {
    position: absolute;
    width: 160px;
    height: 80px;
    top: -8px;
    right: -8px;
    z-index: 10;
  }
  .bottom-cloud {
    position: absolute;
    width: 160px;
    height: 80px;
    bottom: -16px;
    left: -8px;
    z-index: 10;
  }
  .left-star-1 {
    position: absolute;
    width: 50px;
    height: 50px;
    top: 50px;
    left: 10px;
    z-index: 10;
  }
  .left-star-2 {
    position: absolute;
    width: 50px;
    height: 50px;
    top: 10px;
    left: 50px;
    z-index: 10;
  }
  .right-star {
    position: absolute;
    width: 50px;
    height: 50px;
    top: -28px;
    right: 25px;
    z-index: 10;
  }


  .pilars-item-epic {
    position: relative;
    background-image: url('${epic}');
    background-position: center; background-size: cover;
  }
  .icon-item-epic {
    background-image: url('${icon_epic}');
  }

  .epic-blue-body {
    border: 8px solid var(--black);
    background-color: var(--nighttime);
    border-radius: var(--fat-border-radius);
    position: relative;
    display: inline-block;
    width: 100%;
    max-width: 100%;
    min-height: 500px;
    padding-top: 2rem;
    margin-top: 1rem;
    margin-bottom: 3rem;
  }


  .epic-locations-layout {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 1fr 0.3fr;
    row-gap: 0.5rem;
  }
  .hr-divider {
    display: none;
  }

  @media (min-width: 992px) {
    .epic-locations-layout {
      display: grid;
      grid-template-columns: 10fr 1fr 10fr;
      grid-template-rows: 1fr 0.2fr;
      column-gap: 0.5rem;
    }
    .hr-divider {
      display: block;
    }
    .vertical-hr {
      margin-top: 200px;
      width: 1px;
      height: 200px;
      border: 1px solid #fff;
    }

  }


  .epic-left-panel {
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .epic-right-panel {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .epic-left-panel p, .epic-right-panel p {
    font: 18px/28px var(--body-font);
  }
 
  .epic-bottom-panel {
    padding-left: 1rem;
    padding-right: 1rem;

  }
  @media (min-width: 992px) {
    .epic-bottom-panel {
      grid-column: 1 / 4;
    }
    
  }

`

export const About = () => {

  return (
    <Wrapper>
      <div className='lr-padded-container center-text'>
        <h1 style={{marginBottom: '25px'}}>what's on</h1>
        <hr style={{maxWidth: '200px', marginInline: 'auto'}}/>
      </div>

      <div className='lr-padded-container center-text'>
        <p>Over 2 days in Early May, we will be celebrating local tabletop gaming alongside a maker market, workshops and night time events.</p>
      </div>

      <div className='lr-padded-container locations-layout'>
        <div className='st-kilda-item'>
          <div className='clear-header'></div>
          <div className='blue-body center-text'>
            <h3 className='text-orange' style={{paddingTop:'3rem'}}>st kilda</h3>
            Daytime and evening events<br />
            Running 10.00am - 10.30pm
            <div style={{width:'80%', textAlign: 'left', paddingLeft: '3rem'}}>
              <ul>
                <li>D&D 4 Kids</li>
                <li>Blood on the Clocktower</li>
                <li>The Hobbit Hoedown</li>
                <li>Group and party games</li>
                <li>Workshops and presentations</li>
                <li>Maker Market</li>
                <li>D&D Epic TTRPG Events</li>
              </ul>
            </div>
            {/* <a href="to.the.map" className='btn-pink' style={{margin: '0 auto', maxWidth: '170px'}}>map (pdf)</a> */}
            <div className='circle-icon'><img src={icon_st_kilda} alt='st kilda' width='110px' height='110px' style={{paddingTop:'25px'}} /></div>
            <div className='top-cloud'><img src={top_cloud} alt='cloud' /></div>
            <div className='bottom-cloud'><img src={bottom_cloud} alt='cloud' /></div>
          </div>
        </div>
        <div className='port-melbourne-item'>
          <div className='clear-header'></div>
          <div className='blue-body center-text'>
            <h3 className='text-orange' style={{paddingTop:'3rem'}}>port melbourne</h3>
            Daytime and evening events<br />
            Running 11.00am - 11.00pm
            <div style={{width:'80%', textAlign: 'left', paddingLeft: '3rem', paddingRight: '2rem'}}>
              <ul>
                <li>Freeplay<br />Meet and play with local game developers across a range of Australian Indie Tabletop games, offering short intros and longer play.</li>
                <li>Dark Vigil Epic Style</li>
              </ul>
            </div>
            <div className='circle-icon'><img src={icon_port_phillip} alt='st kilda' width='110px' height='110px' style={{paddingTop:'25px'}} /></div>
            <div className='left-star-1'><img src={star} alt='star' /></div>
            <div className='left-star-2'><img src={star} alt='star' /></div>
            <div className='right-star'><img src={star} alt='star' /></div>
          </div>
        </div>
      </div>

      <div className='lr-padded-container center-text' style={{paddingTop: '3rem'}}>
        <h2>Epic TTRPG Events</h2>
        <p>Epic TTRPG Events are large group TTRPG experiences where multiple tables interact to create a grander story.</p>
      </div>

      <div className='lr-padded-container'>
          <div className='item-6 pilars-item pilars-item-epic'><span style={{paddingBottom: '20px'}}>epic TTRPG events after dark</span>
            <div className='icon-item-epic'></div>
          </div>
      </div>

      <div className='lr-padded-container'>
      <div className='epic-blue-body' id='Epic_TTRPG_Events'>
        <div className='epic-locations-layout'>
          <div className='epic-left-panel'>
            <h3 className='text-orange'>Dark Vigil: An Epic TTRPG Game Night</h3>

            <p>The Great Lantern, your town's last hope against the relentless Dark, is burning through Spirit Oil faster than ever before. But it's not just your town in peril—others are facing the same terrifying fate. Without Spirit Oil, survival is no longer measured in months, but weeks, maybe even days.</p>

            <p>Join 74 fearless Venturers from 15 desperate towns and plunge into the heart of the Dark, seeking a solution before it consumes everything. How many will make it back? And if you do, will you still be human?</p>

            <p>Dark Vigil is a thrilling, horror-filled roleplaying game set in a hauntingly twisted Victorian England fantasy world.</p>

            <p>Drinks and Finger Food available.</p>
            <p>MA 18+</p>
            

          </div>
          <div className='hr-divider'><hr className='vertical-hr'/></div>
          <div className='epic-right-panel'>
            <h3 className='text-orange'>D&D 5e Epic</h3>
            <p>The Collegium of the Winged Guard</p>

            <p>Lorlorian has been ravaged by endless war with the cause of the conflict long forgotten. So, when peace is achieved it is cause for great celebration.</p>

            <p>A treaty has finally been signed between the warring nations and a Grand Ball is being held.</p>

            <p>You played a pivotal role in brokering peace and are now a Guest of Honor. The chandeliers gleam, the drinks flow freely, and for the first time in generations there's a genuine sense of joy in the air. But despite the revelry, something is off.</p>
            <ul>
            <li>Why does a nursery rhyme about the Winged Guard echo endlessly in your mind?</li>
            <li>Why does that strange mark on your arm feel like it's burning?</li>
            <li>And why does an overwhelming sense of doom cling to the celebration?</li>
            </ul>
            <p>The Collegium of the Winged Guard is an Epic D&D 5e adventure for 100 lv 14 players with 20 DMs, written to take part over three hours with an overarching storyline and player movement between tables as part of the game play.</p>

            <p>Players will need to make their own character using the guide sent to ticket holders</p>

            <p>Finger Food and Drinks Available</p>
            <p>MA 18+</p>

          </div>
          <div className='epic-bottom-panel center-text'>
            <div><a href="https://events.humanitix.com/port-play" className='btn-pink' style={{margin: '0 auto', maxWidth: '170px'}}>book your slot</a></div>
            <p>Ticket to Portplay does not include entry to Epic TTRPG Events entry.</p>
          </div>
        </div>
        <br />
      </div>
      </div>
    </Wrapper>
  )
}